import React, { useState, useEffect, useContext } from 'react';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import AchievementsList from '../components/Achievements';
import { Trophy, Star, Award, ChevronRight } from 'lucide-react';
import { getCurrentUser } from '../utils/profilesAPI';

/**
 * 成就页面
 * 显示用户已解锁和未解锁的成就
 */
function Achievements({ session }) {
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);

  // 只在组件挂载时获取一次用户数据
  useEffect(() => {
    // 获取用户数据
    const fetchUserProfile = async () => {
      try {
        setLoading(true);
        console.log('获取用户资料中...');
        
        // 使用profilesAPI获取用户资料
        const profile = await getCurrentUser(session);
        
        if (profile) {
          console.log('获取到用户资料:', profile);
          // 使用_id字段，因为数据库中使用的是_id而不是id
          const effectiveId = profile._id || profile.openid || profile._openid;
          console.log('用户ID:', effectiveId);
          if (effectiveId) {
            setUserId(effectiveId);
          }
        } else {
          console.log('未找到用户资料，尝试从本地存储获取');
          // 尝试从本地存储获取
          const userOpenid = localStorage.getItem('user_id');
          if (userOpenid) {
            console.log('从本地存储获取到openid:', userOpenid);
            setUserId(userOpenid);
          }
        }
      } catch (error) {
        console.error('获取用户资料出错:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUserProfile();
  }, [session]); // 只依赖于session变化

  return (
    <div className="min-h-screen app-bg-color pb-20">
      <Header title="我的成就" />
      
      {loading ? (
        <div className="flex items-center justify-center h-40">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
        </div>
      ) : (
        <div className="p-4">
          {/* 成就列表 - 现在置于顶部 */}
          <div className="mb-5">
            {userId ? (
              <AchievementsList userId={userId} />
            ) : (
              <div className="text-center py-4 bg-white rounded-lg shadow-sm">
                <p className="text-gray-500">未找到用户数据</p>
                <p className="text-xs mt-1 text-gray-400">请确保您已登录系统</p>
              </div>
            )}
          </div>
          
          {/* 成就类别卡片 */}
          <div className="bg-white rounded-lg p-5 shadow-sm mb-5">
            <h2 className="text-lg font-bold text-gray-800 mb-4">成就类别</h2>
            
            <div className="space-y-3">
              <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                    <Star className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">学习进度</h3>
                    <p className="text-xs text-gray-500">与学习时间、完成进度相关的成就</p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
              
              <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3">
                    <Award className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">考试成绩</h3>
                    <p className="text-xs text-gray-500">与考试分数、正确率相关的成就</p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
              
              <div className="flex justify-between items-center p-3 bg-purple-50 rounded-lg">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3">
                    <Trophy className="w-5 h-5 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800">特殊成就</h3>
                    <p className="text-xs text-gray-500">与特定里程碑、特殊事件相关的成就</p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
        </div>
      )}
      
      <TabBar />
    </div>
  );
}

export default Achievements;
